import { BaseModel } from "sjs-base-model";
import InfluencersCampaignnDataModel from "./InfluencersCampaignnDataModel";

// InfluencersCampaignDataHitsModel
export default class InfluencersCampaignDataHitsModel extends BaseModel {
    // response getting from the api

    _id = "";
    _index = "";
    _score = 0.0;
    _source = [InfluencersCampaignnDataModel];
    constructor(data) {
        super();
        this.update(data);
    }
}
